/**
 * Reassurance Badges Test Control System
 * 
 * Usage:
 * - Set window.REASSURANCE_TEST_MODE = true to enable test panel
 * - Set window.REASSURANCE_POSITION = 'position1'|'position2'|'position3'|'all'|'none' for production
 * 
 * Positions:
 * - position1: Before variant picker
 * - position2: Before add to cart button
 * - position3: Before store availability (showroom)
 * - all: Show in all positions (for testing)
 * - none: Hide all badges
 */

(function() {
  'use strict';

  // Configuration
  const STORAGE_KEY = 'reassurance_test_position';
  const POSITIONS = {
    NONE: 'none',
    POSITION1: 'position1',
    POSITION2: 'position2',
    POSITION3: 'position3',
    ALL: 'all'
  };

  // Initialize
  function init() {
    console.log('[Reassurance Test] Initializing...', {
      testMode: window.REASSURANCE_TEST_MODE,
      productionPosition: window.REASSURANCE_POSITION
    });

    // Check if test mode is enabled
    if (window.REASSURANCE_TEST_MODE !== true) {
      // Production mode: use window.REASSURANCE_POSITION or default to position3
      const productionPosition = window.REASSURANCE_POSITION || 'position3';
      console.log('[Reassurance Test] Production mode, applying position:', productionPosition);
      applyPosition(productionPosition, false);
      return;
    }

    // Test mode: show panel and load saved position
    const panel = document.getElementById('reassurance-test-panel');
    if (!panel) {
      console.error('[Reassurance Test] Panel not found in DOM!');
      return;
    }

    console.log('[Reassurance Test] Test mode enabled, showing panel');
    panel.style.display = 'block';
    testModeInitialized = true;
    
    // Load saved position from localStorage
    const savedPosition = localStorage.getItem(STORAGE_KEY) || POSITIONS.POSITION3;
    console.log('[Reassurance Test] Loading saved position:', savedPosition);
    applyPosition(savedPosition, true);
    updateUI(savedPosition);

    // Setup event listeners
    setupEventListeners();
  }

  // Track if test mode has been initialized
  let testModeInitialized = false;

  // Expose init function globally so it can be called after setting REASSURANCE_TEST_MODE
  window.reassuranceTestInit = init;

  // Apply position to badges
  function applyPosition(position, isTestMode) {
    // Get all badge containers
    const badges = document.querySelectorAll('[data-reassurance-position]');
    
    badges.forEach(function(badge) {
      const badgePosition = badge.getAttribute('data-reassurance-position');
      
      if (position === POSITIONS.NONE) {
        badge.style.display = 'none';
      } else if (position === POSITIONS.ALL) {
        badge.style.display = '';
      } else {
        // Show only the selected position
        badge.style.display = (badgePosition === position) ? '' : 'none';
      }
    });

    // Update localStorage only in test mode
    if (isTestMode) {
      localStorage.setItem(STORAGE_KEY, position);
    }
  }

  // Update UI to reflect current position
  function updateUI(position) {
    // Update status text
    const statusEl = document.getElementById('reassurance-test-current-position');
    if (statusEl) {
      const labels = {
        'none': 'Ne rien afficher',
        'position1': 'Avant sélection variante',
        'position2': 'Avant bouton ajout panier',
        'position3': 'Avant retrait showroom',
        'all': 'Tout afficher'
      };
      statusEl.textContent = labels[position] || position;
    }

    // Update active button
    const buttons = document.querySelectorAll('.reassurance-test-panel__option');
    buttons.forEach(function(btn) {
      if (btn.getAttribute('data-position') === position) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  // Setup event listeners
  function setupEventListeners() {
    // Position buttons
    const buttons = document.querySelectorAll('.reassurance-test-panel__option');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const position = this.getAttribute('data-position');
        applyPosition(position, true);
        updateUI(position);
      });
    });

    // Close button
    const closeBtn = document.querySelector('.reassurance-test-panel__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        const panel = document.getElementById('reassurance-test-panel');
        if (panel) {
          panel.style.display = 'none';
        }
      });
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also check periodically if test mode was enabled after page load
  // This allows setting window.REASSURANCE_TEST_MODE = true in console
  let checkInterval = setInterval(function() {
    if (window.REASSURANCE_TEST_MODE === true && !testModeInitialized) {
      const panel = document.getElementById('reassurance-test-panel');
      if (panel) {
        console.log('[Reassurance Test] Test mode detected after page load, initializing...');
        clearInterval(checkInterval);
        init();
      }
    }
  }, 500);

  // Clear interval after 30 seconds to avoid infinite checking
  setTimeout(function() {
    if (checkInterval) {
      clearInterval(checkInterval);
      console.log('[Reassurance Test] Stopped checking for test mode (timeout)');
    }
  }, 30000);

  // Register init callback with the getter/setter defined in theme.liquid
  if (typeof window.__reassuranceTestSetInitCallback === 'function') {
    window.__reassuranceTestSetInitCallback(function() {
      if (!testModeInitialized) {
        init();
      }
    });
  }
})();

